import { render, staticRenderFns } from "./TrCheckBoxV2.vue?vue&type=template&id=5f2f303e&scoped=true&"
import script from "./TrCheckBoxV2.vue?vue&type=script&lang=js&"
export * from "./TrCheckBoxV2.vue?vue&type=script&lang=js&"
import style0 from "./TrCheckBoxV2.vue?vue&type=style&index=0&id=5f2f303e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f303e",
  null
  
)

export default component.exports